import React from "react";
import {BreadCrumbItem} from "../../organisms/HeaderSection";
import Page from "../../organisms/Page";
import FormSection from "./FormSection";

const breadCrumbs: BreadCrumbItem[] = [
    {
        path: "/",
        label: "Inicio"
    },
    {
        path: "/servicios",
        label: "Servicios",
    },
    {
        path: "/servicios/spa",
        label: "Spa",
    },
    {
        path: "/editar",
        label: "Editar",
        isActive: true
    }
]

function EditarServicioSpa(){
    return (
        <Page title="Edición de servicio de spa" description="Modificación de servicios de spa." breadCrumbs={breadCrumbs}>
            <FormSection />
        </Page>
    );
}

export default EditarServicioSpa;